<template>
  <v-col>
    <v-card-text>
      <h1>
        {{ appointment.environment === 'virtual' ? 'Virtual' : 'In-Clinic' }}
        {{ appointment.type === 'first' ? 'First Visit' : 'Follow-Up' }}
      </h1>
      <span class="d-block mb-4">
        <v-icon small>mdi-clock-time-eight-outline</v-icon> {{ duration }}min</span
      >
      <p class="body-1">On {{ dateFormatted }}</p>
    </v-card-text>
  </v-col>
</template>
<script>
import moment from 'moment';

import { APPOINTMENT_DURATION } from '../constants/appointment';
import { DATE_FORMAT, PRETTY_DATE_FORMAT, TIME_FORMAT } from '../constants/moment';

export default {
  name: 'Confirmation',
  data: () => ({}),
  mounted() {
    this.$store.commit('updateAppointment', { title: 'Here are the details' });
  },

  computed: {
    appointment() {
      return this.$store.state.appointment;
    },
    duration() {
      return APPOINTMENT_DURATION[this.appointment.environment][this.appointment.type];
    },
    dateFormatted() {
      const { time, date } = this.appointment;
      const initial = moment.unix(time);

      return `${moment(date, DATE_FORMAT).format(PRETTY_DATE_FORMAT)} from ${initial.format(
        TIME_FORMAT
      )} to ${initial.add(this.duration, 'minutes').format(TIME_FORMAT)}`;
    },
  },
};
</script>
